<script setup lang="ts">
const props = defineProps<{
  distance: number
  latitude: number
  longitude: number
  userLocation?: { lat: number; lng: number }
}>()

const { t } = useLocale()

const googleMapsURL = computed(() =>
  getGoogleMapsUrl(
    {
      lat: props.latitude,
      lng: props.longitude,
    },
    props.userLocation
  )
)

const distanceStr = computed(() => {
  if (!props.distance) return ''
  if (props.distance <= 100) {
    return `${Math.floor(props.distance)} m`
  } else if (props.distance <= 1000) {
    const count = (props.distance / 1000).toFixed(2)
    return `${count} km`
  } else return `${Math.floor(props.distance / 1000)} km`
})
</script>

<template>
  <div class="flex justify-between text-xs tracking-[-0.15px]">
    <NuxtLink
      external
      :href="googleMapsURL"
      target="_blank"
      class="flex gap-2 text-[10px] text-mcd-secondaryBlue"
    >
      {{ t('restaurant.detail.howToArrive') }}
      <img src="/images/icons/arrowRightBlue.svg" alt="arrow-right" />
    </NuxtLink>

    <div v-if="distance" class="hidden h-fit flex-row self-end text-mcd-secondaryDarkGrey md:flex">
      <img src="/images/icons/distance.svg" class="h-4 fill-mcd-secondaryDarkGrey" alt="distance" />
      <p>
        {{ distanceStr }}
      </p>
    </div>
  </div>
</template>
